import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { MUNICIPALITIES_FILE, Municipality } from '../components/shared/utils/municipality.utils';

@Injectable({
  providedIn: 'root'
})
export class MunicipalityService {

  constructor(private http: HttpClient) {}

  getMunicipalityByCap(cap: string): Observable<Municipality | undefined> {
    return this.http.get<Municipality[]>(MUNICIPALITIES_FILE).pipe(
      map(municipalities =>
        municipalities.find(municipality => municipality.cap.includes(cap))
      )
    );
  }
}
